import { render, staticRenderFns } from "./WorkTable976.vue?vue&type=template&id=5ab675d0&scoped=true"
import script from "./WorkTable976.vue?vue&type=script&lang=js"
export * from "./WorkTable976.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab675d0",
  null
  
)

export default component.exports